import { render, staticRenderFns } from "./Dryness.vue?vue&type=template&id=3b33bab6"
import script from "./Dryness.vue?vue&type=script&lang=js"
export * from "./Dryness.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports